// Auto-generated by scripts/discover-tools.ts. Do not edit.
import { lazy } from 'react';
import { Tool } from './tools';

import { metadata as cocktailMixerMetadata } from '../tools/cocktail-mixer/metadata';
import { metadata as hackerNewsMetadata } from '../tools/hacker-news/metadata';
import { metadata as namePredictorMetadata } from '../tools/name-predictor/metadata';
import { metadata as nasaApodMetadata } from '../tools/nasa-apod/metadata';
import { metadata as onThisDayMetadata } from '../tools/on-this-day/metadata';
import { metadata as pokedexMetadata } from '../tools/pokedex/metadata';
import { metadata as randomRecipeMetadata } from '../tools/random-recipe/metadata';
import { metadata as sunriseSunsetMetadata } from '../tools/sunrise-sunset/metadata';
import { metadata as triviaQuizMetadata } from '../tools/trivia-quiz/metadata';
import { metadata as whoInSpaceMetadata } from '../tools/who-in-space/metadata';

export const discoveredTools: Tool[] = [
  cocktailMixerMetadata as any,
  hackerNewsMetadata as any,
  namePredictorMetadata as any,
  nasaApodMetadata as any,
  onThisDayMetadata as any,
  pokedexMetadata as any,
  randomRecipeMetadata as any,
  sunriseSunsetMetadata as any,
  triviaQuizMetadata as any,
  whoInSpaceMetadata as any,
];

export const discoveredPages: Record<string, () => Promise<any>> = {
  'cocktail-mixer': () => import('../tools/cocktail-mixer/page'),
  'hacker-news': () => import('../tools/hacker-news/page'),
  'name-predictor': () => import('../tools/name-predictor/page'),
  'nasa-apod': () => import('../tools/nasa-apod/page'),
  'on-this-day': () => import('../tools/on-this-day/page'),
  'pokedex': () => import('../tools/pokedex/page'),
  'random-recipe': () => import('../tools/random-recipe/page'),
  'sunrise-sunset': () => import('../tools/sunrise-sunset/page'),
  'trivia-quiz': () => import('../tools/trivia-quiz/page'),
  'who-in-space': () => import('../tools/who-in-space/page'),
};
